import { CarRentalState } from './index';
import { MutationTree } from 'vuex';
import CheckoutItem from "../interfaces/checkoutItem";

export default {
    setAvailableCarRentals(state: CarRentalState, response) {
        state.availableCarRentals = response.days;
        state.availableExtras = response.extras;
    },
    initCarRentals(state: CarRentalState, [carRentals, carExtras]) {
        state.carRentals = carRentals;
        state.carExtras = carExtras;
    },
    setCarRentals(state: CarRentalState, [key, carRentals]) {
        state.carRentals[key] = carRentals;
    },
    resetCarRentals(state: CarRentalState) {
        state.carRentals = {};
        state.carExtras = [];
    },
    increaseCarExtrasAmount(state: CarRentalState, carExtra) {
        const item: CheckoutItem | undefined = state.carExtras.find((checkoutItem: CheckoutItem) => checkoutItem.id === carExtra.id);

        if(item !== undefined) {
            item.amount++;
        } else {
            const extra = state.availableExtras.find(extra => extra.id === carExtra.id);
            // @ts-ignore
            state.carExtras.push({ ...extra, amount: 1 });
        }
    },
    decreaseCarExtrasAmount(state: CarRentalState, carExtra) {
        const item: CheckoutItem | undefined = state.carExtras.find((checkoutItem: CheckoutItem) => checkoutItem.id === carExtra.id);

        if(item === undefined) {
            return;
        }

        item.amount--;
        if(item.amount === 0) {
            state.carExtras.forEach((checkoutItem: CheckoutItem, index: number)=>{
                if(checkoutItem.id === item.id) {
                    state.carExtras.splice(index, 1);
                }
            });
        }
    },
} as MutationTree<CarRentalState>
